import React from 'react';
import { BsFacebook } from 'react-icons/bs';
import { BsTwitter } from 'react-icons/bs';
import { AiOutlineLinkedin } from 'react-icons/ai';
import { TfiYoutube } from 'react-icons/tfi';

const Footer = () => {

    return (
        <div className='bg-slate-200 p-10'>
            <div className=' grid xl:grid-cols-6 lg:grid-cols-4 sm:grid-cols-3 
            max-[500px]:grid-cols-1 grid-cols-2'>
                <div className=' flex justify-center max-[500px]:text-center border-r-2 max-[500px]:border-b-2 max-[500px]:border-r-0 border-dotted border-blue-900 text-slate-700 my-2 py-1'>
                    <div>
                        <h4 className='text-lg font-bold uppercase text-blue-900'>Home</h4>
                        <p><a href='/#maya'>Maya Japanese</a></p>
                        <p><a href='/#coach'>Get Coached</a></p>
                        <p><a href='/#join'>Join me</a></p>
                        <p><a href='/#all'>News</a></p>
                        <p><a href='/#social'>social</a></p>
                    </div>
                </div>
                <div className='flex justify-center max-[500px]:text-center border-r-2 max-[500px]:border-b-2 max-[500px]:border-r-0 border-dotted border-blue-900 text-slate-700 my-2 py-1'>
                    <div>
                        <h4 className=' text-lg font-bold uppercase text-blue-900'>My Stories</h4>
                        <p><a href='/stories#early-life'>Early Life</a></p>
                        <p><a href='/stories#education'>Education</a></p>
                        <p><a href='/stories#certificate'>Certification</a></p>
                        <p><a href='/stories#certificate'>Contribution</a></p>
                        <p><a href='/stories'>Software Professional</a></p>
                        <p><a href='/stories'>Join RK</a></p>
                    </div>
                </div>
                <div className='flex justify-center max-[500px]:text-center border-r-2 max-[500px]:border-b-2 max-[500px]:border-r-0 border-dotted border-blue-900 text-slate-700 my-2 py-1'>
                    <div>
                        <h4 className=' text-lg font-bold uppercase text-blue-900'>Japanese Center</h4>
                        <p><a href='/japanese#services'>Job in Japan</a></p>
                        <p><a href='/japanese#services'>Immigrate to Japan</a></p>
                        <p><a href='/japanese#services'>Study in Japan</a></p>
                        <p><a href='/japanese#services'>Support in Japan</a></p>
                        <p><a href='/japanese#about-japan'>Explore in Japan</a></p>
                        <p><a href='/japanese#free-consult'>Free Consultation</a></p>
                    </div>
                </div>
                <div className='flex justify-center max-[500px]:text-center border-r-2 max-[500px]:border-b-2 max-[500px]:border-r-0 border-dotted border-blue-900 text-slate-700 my-2 py-1'>
                    <div>
                        <h4 className=' text-lg font-bold uppercase text-blue-900'>Coaching</h4>
                        <p><a href='/coach#coach'>Life Coaching</a></p>
                        <p><a href='/coach#coach'>Relationship Counselings</a></p>
                        <p><a href='/coach#coach'>Grief Support</a></p>
                        <p><a href='/coach#coach'>Goal Settings</a></p>
                        <p><a href='/coach#coach'>Self Development</a></p>
                    </div>
                </div>
                <div className='flex justify-center max-[500px]:text-center border-r-2 max-[500px]:border-b-2 max-[500px]:border-r-0 border-dotted border-blue-900 text-slate-700 my-2 py-1'>
                    <div>
                        <h4 className=' text-lg font-bold uppercase text-blue-900'>Research</h4>
                        <p><a href='/research'>Artificial Intelligence</a></p>
                        <p><a href='/research'>Project Management</a></p>
                        <p><a href='/research'>Conferenies</a></p>
                        <p><a href='/research'>Purlications</a></p>
                        <p><a href='/research'>Join a Research</a></p>
                    </div>
                </div>
                <div className='flex justify-center max-[500px]:text-center border-r-2 max-[500px]:border-b-2 max-[500px]:border-r-0 border-dotted border-blue-900 text-slate-700 my-2 py-1'>
                    <div>
                        <h4 className=' text-lg font-bold uppercase text-blue-900'>Contact</h4>
                        <p><a href='/contact#join'>Join RK Newsletter</a></p>
                        <p><a href='/contact#consultation'>Free Consultation</a></p>
                        <p><a href='/contact#write-rk'>Write RK</a></p>
                    </div>
                </div>
                {/* <div className=' flex justify-center '>
                    <div>
                        <h4 className=' text-lg font-bold uppercase text-blue-900 '>Health</h4>
                        <p><a to='#'>Mental Fitness</a></p>
                        <p><a to='#'>Physical Health</a></p>
                        <p><a to='#'>21 Days Challenge</a></p>
                        <p><a to='#'>Free Fitness Prousram</a></p>
                    </div>
                </div> */}
            </div>

            <div className='flex items-center gap-4 mt-10 md:mx-16 font-bold'>
                <span className=' text-blue-900'>Connect with RK</span>
                <a target='_blank' href='https://www.facebook.com/rabinandan.in/' className=' rounded-full border-2 border-slate-400 p-1'><BsFacebook className=' text-xl text-slate-500' /></a>
                <a target='_blank' href='https://twitter.com/Rabi_Nandan' className=' rounded-full border-2 border-slate-400 p-1'><BsTwitter className=' text-xl text-slate-500' /></a>
                <a target='_blank' href='https://www.youtube.com/channel/UCDhmFI0iZ_M7S5mD4xDRK-A' className=' rounded-full border-2 border-slate-400 p-1'><TfiYoutube className=' text-xl text-slate-500' /></a>
                <a target='_blank' className=' rounded-full border-2 border-slate-400 p-1' href="https://www.aedin.com/in/rabinandan-kishor/"> <AiOutlineLinkedin className=' text-xl text-slate-500' /></a>
            </div>
        </div>
    );
};

export default Footer;